const $ = require('jquery'), transition = require('../../../common/components/transition/transition-events.js');

module.exports = function (categoriesService, $state, $timeout, specialsGroupsService, shopperService, breakpointsService, settingsService, settingsByBreakpoint, moveFocus, pageMetadataService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope, element) {

            // Toggle behaviour
            scope.displayOptions = [{ text: 'Type' }, { text: 'Category' }];

            let isScrollerOpen = $state.$current.params.isScrollerOpen;

            if (!isScrollerOpen) {
                isScrollerOpen = $state.$current.data !== undefined && $state.$current.data.isScrollerOpen;
            }

            scope.selectedDisplay = scope.displayOptions[isScrollerOpen ? 1 : 0];
            scope.shopper = shopperService;
            scope.breakpoints = breakpointsService;

            function containRecency(sortTypes) {
                for (let i = 0; i < sortTypes.length; i++) {
                    if (sortTypes[i].Text === 'Recency') {
                        return true;
                    }
                }
                return false;
            }

            // Remove the 'Recency' option from the sorting list for category display type.
            function filterSortTypes() {
                settingsService.getSettingValue('Specials', 'SortOptions').then(function (sortTypes) {
                    if (containRecency(sortTypes)) {
                        sortTypes.pop();
                    }
                });
            }

            function update() {
                if (scope.selectedDisplay.text === scope.displayOptions[1].text) {
                    $state.go('shop.specials.browse', { aisle: null, category: null }).then(function () {
                        filterSortTypes();
                    });
                } else {
                    $state.go('shop.specials.groupsv2');
                }
            }

            function collapsibleSpinnerEnabled() {
                return settingsByBreakpoint.getSettingValueByBreakpoint('VisualShopping',
                {
                    largeFormat: 'CollapseCategoriesInLargeFormat',
                    mediumFormat: 'CollapseCategoriesInMediumFormat',
                    smallFormat: 'CollapseCategoriesInSmallFormat'
                });
            }

            function hidePanel(panelSelector) {
                // display both panels
                element.find('.specialsGroups, .categorySpinner').removeClass('u-displayNone');
                // hide the panels ou of screen after transition
                element.find(panelSelector).addClass('u-displayNone');
            }

            function initPanels() {
                const panelToHide = scope.selectedDisplay.text === scope.displayOptions[1].text
                    ? '.specialsGroups'
                    : '.categorySpinner';
                hidePanel(panelToHide);
            }

            function init() {
                return categoriesService.getAll(true)
                    .then(function () {
                        categoriesService.currentCategory.parentCategory = categoriesService.currentCategory.department;
                        categoriesService.currentCategory.childCategory = categoriesService.currentCategory.aisle;
                        scope.categoriesService = categoriesService;
                    })
                    .then(collapsibleSpinnerEnabled)
                    .then(function (enabled) {
                        scope.isSpinnerCollapsible = enabled;
                        $timeout(initPanels);
                    });
            }

            function displaySelectedPanel() {
                const isCategory = scope.selectedDisplay.text === scope.displayOptions[1].text;

                // Check if the selected option is the same as current
                const isSameSelection = $('.specialsGroups, .categorySpinner')
                    .filter(':visible')
                    .hasClass(isCategory ? 'categorySpinner' : 'specialsGroups');
                if (!isSameSelection) {
                    // Hide current panel, and show selected panel
                    hidePanel(isCategory ? '.specialsGroups' : '.categorySpinner');

                    // Wait till transition ends, then move focus so transition is smooth
                    transition.onTransitionEnd(element, function () {
                        moveFocus(isCategory ? '.categorySpinner' : '.specialsGroups');
                    });
                } else {
                    // No transition, so just move back to navigation panel
                    moveFocus(isCategory ? '.categorySpinner' : '.specialsGroups');
                }
            }

            function resetPanels() {
                // get default scroller options from state data
                scope.selectedDisplay = scope.displayOptions[$state.$current.data.isScrollerOpen ? 1 : 0];
                initPanels();
                init();
            }

            function toggleDisplay() {
                if (scope.selectedDisplay.text === scope.displayOptions[0].text) {
                    scope.selectedDisplay = scope.displayOptions[1];
                } else {
                    scope.selectedDisplay = scope.displayOptions[0];
                }
                displaySelectedPanel();
            }

            initPanels();

            scope.stateOptions = {
                state: 'shop.specials.browse.category.aisle',
                category: 'category',
                subCategory: 'aisle'
            };

            scope.dropdownChange = function () {
                displaySelectedPanel();
                update();
            };

            scope.shouldShowTypes = function () {
                return scope.selectedDisplay.text === scope.displayOptions[0].text;
            };
            scope.shouldShowCategories = function () {
                return scope.selectedDisplay.text === scope.displayOptions[1].text;
            };

            scope.$on('categories:invalidated', function (e, data) {
                if (!data.willRedirect) {
                    init();
                }
            });

            scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };

            scope.selectCategory = function (selectedCategory) {
                categoriesService.setSelectedCategory(selectedCategory.parentCategory, selectedCategory.childCategory);
            };

            scope.$on('inlineCoaching-specials:toggleView', toggleDisplay);
            scope.$on('inlineCoaching-specials:end', resetPanels);
            scope.$on('address-update', function () {
                specialsGroupsService.invalidateSpecialGroups();
                init();
            });
            scope.$on('$stateChangeStart', function (event, toState) {
                if (toState.name !== 'shop.specials.groupsv2' && toState.name !== 'shop.specials.groups' && toState.name !== 'shop.specials.landing') {
                    pageMetadataService.updateMetadata({ name: '' }, true, null, 'Special', false);
                }
            });

            init();
        },
        template: require('./specials-navigation-template-v2.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-navigation-directive-v2.js
 **/